var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4163 33.542H28.6663M31.583 39.3753H28.6663M40.333 27.7087H28.6663M46.1663 27.417V42.5837C46.1663 45.0339 46.1663 46.259 45.6895 47.1949C45.27 48.0181 44.6008 48.6874 43.7775 49.1068C42.8417 49.5837 41.6166 49.5837 39.1663 49.5837H29.833C27.3828 49.5837 26.1577 49.5837 25.2218 49.1068C24.3986 48.6874 23.7293 48.0181 23.3099 47.1949C22.833 46.259 22.833 45.0339 22.833 42.5837V27.417C22.833 24.9668 22.833 23.7416 23.3099 22.8058C23.7293 21.9826 24.3986 21.3133 25.2218 20.8938C26.1577 20.417 27.3828 20.417 29.833 20.417H39.1663C41.6166 20.417 42.8417 20.417 43.7775 20.8938C44.6008 21.3133 45.27 21.9826 45.6895 22.8058C46.1663 23.7416 46.1663 24.9668 46.1663 27.417Z",
    stroke: "#F25454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.99fb2488da51ac0c62f16484d429d18c.svg";
export { ForwardRef as ReactComponent };